import { baseDetailsTakeUrl } from './take.urls';
import { IDynamicLottieChange } from 'lottie-json-helper/lib/types';
import { ITakeDynamicLottieContext } from '../../../../../models/project/take/take-model';

const DYNAMIC_LOTTIE_URL = '/dynamic-lottie';
function getBaseDynamicLottiePath(projectId: string, sceneId: string, takeId: string, dynamicLottieId: string) {
    const baseTakePath = baseDetailsTakeUrl(projectId, sceneId, takeId);

    return `${baseTakePath}${DYNAMIC_LOTTIE_URL}/${dynamicLottieId}`;
}

export function getUpdateDynamicLottieImagePathPUTUrl(
    projectId: string,
    sceneId: string,
    takeId: string,
    dynamicLottieId: string
) {
    const basicLottiePath = getBaseDynamicLottiePath(projectId, sceneId, takeId, dynamicLottieId);

    return `${basicLottiePath}/image`;
}

export function getUploadImageToTakePOSTUrl(
    projectId: string,
    sceneId: string,
    takeId: string,
    dynamicLottieId: string
) {
    const basicLottiePath = getBaseDynamicLottiePath(projectId, sceneId, takeId, dynamicLottieId);

    return `${basicLottiePath}/image`;
}

export function getUpdateFontForDynamicLottiePUTUrl(dynamicLottieContext: ITakeDynamicLottieContext) {
    if (!dynamicLottieContext) {
        throw new Error('Could not ');
    }
    const { dynamicLottieId, takeId, sceneId, projectId } = dynamicLottieContext;
    const basicLottiePath = getBaseDynamicLottiePath(projectId, sceneId, takeId, dynamicLottieId);

    return `${basicLottiePath}/font`;
}
